import { combineReducers } from 'redux';
import byId, * as fromById from './byId';

/* Reducers: */
const listByEdition = (state = { isFetching: false }, action) => {
  switch (action.type) {
    case 'REQUEST_PROJECTS': // eslint-disable-line no-case-declarations
      return { ...state, isFetching: true };
    case 'RECIEVE_PROJECTS': // eslint-disable-line no-case-declarations
      if (typeof action.edition.id === 'undefined') {
        return state;
      }
      const editionID = action.edition.id;
      const idsByEdition = { [editionID]: action.response.map(project => project.id) };
      return { ...state, ...idsByEdition, isFetching: false };
    default:
      return state;
  }
};


const projects = combineReducers({
  listByEdition,
  byId,
});

export default projects;

/* Selectors: */
export const getVisibleProjects = (state, edition) => {
  if (typeof edition === 'undefined' || typeof edition.id === 'undefined') {
    return [];
  }
  const ids = state.listByEdition[edition.id];
  return ids ? ids.map(id => fromById.getProject(state.byId, id)) : [];
};

export const getIsFetching = state => state.listByEdition.isFetching;

export const getProject = (state, id) =>
  fromById.getProject(state.byId, id);



// WEBPACK FOOTER //
// ./js/reducers/projects/index.js